<template>
  <div v-if="comment" :class="$style.container">
    <div :class="$style.textContainer">
      <span
        v-if="user"
        :class="$style.name"
        @click="showProfile"
      >{{ name }}</span>
      <ContentLoader
        v-else
        width="90" height="18"
        :class="$style.userLoader"
      >
        <rect x="0" y=5 rx="4" ry="4" width="90" height="8" />
      </ContentLoader>
      <span :class="$style.text">{{ comment.text }}</span>
    </div>
    <div :class="$style.actions">
      <v-popover placement="bottom-end" popoverClass="no-arrow">
        <div :class="$style.actionButton">
          <BaseIcon custom name="ellipsisX" :class="['tooltip-target']" />
        </div>
        <MenuBase
          slot="popover" v-close-popover
          :options="menu"
        />
      </v-popover>
      <div :class="$style.time">{{ time }}</div>
      <div v-if="!comment.replyTo" :class="$style.replyBtn" @click="isShowInput = !isShowInput">{{ $t('btnReply') }}</div>
      <div
        v-if="repliesCountDisplay"
        :class="$style.replyBtn"
        @click="toggleReplies"
      >
        {{ isRepliesOpened ? $t('btnHide') : $t('btnShow') }} {{ repliesCountDisplay }} {{ $tc('socialPost.replies', repliesCountDisplay) }}
      </div>
    </div>
    <div v-if="isRepliesOpened" :class="$style.replies">
      <SocialCommentsListItem
        v-for="reply in replies" :key="reply.id"
        :comment="reply"
      />
    </div>
    <SocialCommentInput
      v-if="isShowInput"
      :postId="comment.postId"
      :replyTo="comment"
      @close="isShowInput = false"
    />
    <SocialCommentInput
      v-if="isShowEditInput"
      :postId="comment.postId"
      :editedComment="comment"
      @close="isShowEditInput = false"
    />
  </div>
</template>

<script>
import { ContentLoader } from 'vue-content-loader'
import { formatDistanceToNow } from '@/utils/date'
import { mapActions, mapGetters } from 'vuex'
import SocialCommentInput from './SocialCommentInput'
import MenuBase from '@/components/MenuBase'

export default {
  name: 'social-comments-list-item',
  components: {
    ContentLoader,
    SocialCommentInput,
    MenuBase
  },
  props: {
    comment: Object
  },
  data () {
    return {
      isRepliesOpened: false,
      isShowInput: false,
      isShowEditInput: false,
      menuMy: [
        {
          name: this.$t('buttonEdit'),
          icon: 'pencil-alt',
          handler: () => {
            this.isShowEditInput = true
          }
        },
        {
          name: this.$t('buttonDelete'),
          icon: 'trash-alt',
          handler: () => {
            const text = this.comment.text.length < 20 ? this.comment.text : this.comment.text.slice(0, 20) + '...'
            this.$modal.show('confirm', {
              content: this.$t('socialComment.deleteConfirmation', { text }),
              onSubmit: this.onDelete
            })
          }
        }
      ],
      menuFollower: [
        {
          name: this.$t('socialPost.reportButton'),
          icon: 'exclamation-triangle',
          handler: () => {
            this.$modal.show('confirm', {
              content: this.$t('socialPost.commentReportConfirmation'),
              onSubmit: () => {
                this.$modal.show('info', { text: this.$t('socialPost.reportText') })
              }
            })
          }
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      getCommentReplies: 'entities/socialComments/getCommentReplies',
      getCommentRepliesCount: 'entities/socialComments/getCommentRepliesCount'
    }),
    user () {
      return this.comment.userObj
    },
    name () {
      if (!this.user) return
      return this.user.displayName
    },
    time () {
      return formatDistanceToNow(new Date(this.comment.createdAt))
    },
    repliesCountDisplay () {
      const repliesLocalCount = this.getCommentRepliesCount(this.comment.id)
      return this.comment.repliesCount < repliesLocalCount ? repliesLocalCount : this.comment.repliesCount
    },
    replies () {
      return this.getCommentReplies(this.comment.id)
    },
    menu () {
      return this.comment.isOwn ? this.menuMy : this.menuFollower
    }
  },
  methods: {
    ...mapActions({
      fetchReplies: 'entities/socialComments/fetchReplies',
      deleteComment: 'entities/socialComments/deleteComment'
    }),
    onDelete () {
      this.deleteComment(this.comment.id)
    },
    toggleReplies () {
      this.isRepliesOpened = !this.isRepliesOpened
      if (this.isRepliesOpened) {
        this.onFetchReplies()
      }
    },
    onFetchReplies () {
      this.fetchReplies({ postId: this.comment.postId, commentId: this.comment.id })
    },
    showProfile (user) {
      this.$modal.show('profile', {
        userId: this.user.userId
      })
    }
  }
}
</script>

<style module lang="scss">
.container {
  margin: 5px 0;
}
.textContainer {
  min-height: 18px;
}
.name {
  font-weight: 500;
  color: $text-colored;
  cursor: pointer;
}
.userLoader {
  height: 18px;
  vertical-align: text-bottom;
}
.text {
  margin-left: 4px;
}
.actions {
  display: flex;
  color: $text-mid;
  align-items: center;
}
.time {
  margin-left: 12px;
}
.replyBtn {
  margin-left: 12px;
  cursor: pointer;
  &:hover {
    color: $text-darkest;
  }
}
.replies {
  padding-left: 24px;
}
.actionButton {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 18px;
  &:hover {
    color: $text-darkest;
  }
}
</style>
